// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";

type $Props = {
  classes: Object,
  compliance: Object,
  footerPod: string,
  hideFooterDisclaimer: boolean,
};

const Disclaimer = ({
  classes,
  compliance,
  footerPod,
  hideFooterDisclaimer,
}: $Props) => {
  if (
    compliance &&
    compliance.footerDisclaimers &&
    compliance.footerDisclaimers.length &&
    !hideFooterDisclaimer
  ) {
    return (
      <div
        className={classNames({
          [classes.root]: true,
          [classes.threeCols]: footerPod === "threeCols",
          [classes.twoLevel]: footerPod === "twoToneAndTwoLevelFooter",
        })}
      >
        {compliance.footerDisclaimers.map((disclaimer, idx) => {
          return (
            <div key={idx} className={classes.disclaimer}>
              {disclaimer.watermark ? (
                <div className={"ref__footer-disclaimer-compliance-image"}>
                  <img
                    src={disclaimer.watermark}
                    alt="Compliance"
                    className={disclaimer.class || classes.watermark}
                  />
                </div>
              ) : null}
              <div
                className={classNames(
                  "ref__footer-compliance-text",
                  classes.complianceText
                )}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: disclaimer.text,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
};

const styles = (theme) => {
  return {
    "@global": {
      ".compliance-thumbnail-image": {
        position: "relative",
        top: "-32px",
        marginBottom: theme.spacing.unit * -1.5,
        textAlign: "right",
      },
      "img.watermark-logo": {
        border: theme.borders["default"],
        boxShadow: "3px 3px 10px 1px rgba(0, 0, 0, 0.4)",
        maxWidth: "55px",
      },
      "img.ccar-logo": {
        border: theme.borders["default"],
        boxShadow: "3px 3px 10px 1px rgba(0, 0, 0, 0.4)",
        maxWidth: "100px",
      },

      "img.realcomp-logo": {
        border: theme.borders["default"],
        boxShadow: "3px 3px 10px 1px rgba(0, 0, 0, 0.4)",
        maxWidth: "100px",
        padding: theme.spacing.unit * 0.25,
      },
      "img.cci-logo": {
        maxWidth: "150px",
      },
      "img.sd-logo": {
        maxWidth: "100px",
      },
      "img.armls-logo": {
        maxWidth: "55px",
      },
      "img.newyorkalliance-logo": {
        maxWidth: "55px",
      },
      "img.gflr-logo": {
        maxWidth: "300px",
      },
      "img.globalmls-logo": {
        maxWidth: "300px",
      },
      "img.ntreismls-logo": {
        maxHeight: "100px",
      },
      "img.compliance-logo-large": {
        maxWidth: "100px",
      },
      "img.nneren-logo": {
        maxWidth: "100px",
      },
      "img.canopy-logo": {
        maxWidth: "150px",
      },
      "img.smart-mls-logo": {
        maxWidth: "100px",
      },
      "img.trianglemls-logo": {
        maxWidth: "100px",
        marginRight: "3px",
      },
      "img.ecoar-logo": {
        maxWidth: "100px",
        marginRight: "3px",
      },
    },
    root: {
      display: "block",
      position: "relative",
      width: "100%",
      padding: "20px 0",
      color: (props) =>
        props.footerPod === "threeCols"
          ? theme.colors.primaryFontColor
          : "#fff",
    },
    threeCols: {
      backgroundColor: theme.colors.primary["500"],
    },
    twoLevel: {
      backgroundColor: theme.colors.gray["900"],
    },
    disclaimer: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
    watermark: {
      width: "auto",
      maxWidth: "55px",
      height: "auto",
      border: theme.borders["default"],
      boxShadow: "3px 3px 10px 1px rgba(0,0,0,.4)",
    },
    complianceText: {
      width: "100%",
      maxWidth: "900px",
      padding: "20px 15px 0",
      textAlign: "center",
    },
  };
};

export default withGlobalContext(withStyles(styles)(Disclaimer));
